exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropDownBox[data-v-9f2058c0]{\n  height:0px;\n  z-index:auto;\n  overflow:hidden;\n  -webkit-animation:mymove .5s 1;\n          animation:mymove .5s 1;\n  -webkit-animation-fill-mode:forwards;\n          animation-fill-mode:forwards;\n  background:#fff;\n  -webkit-box-shadow:0px 2px 8px rgba(37,44,54,.25);\n          box-shadow:0px 2px 8px rgba(37,44,54,.25)\n}", ""]);

// exports
